import React, { createContext, useContext, useRef, useState, useEffect } from 'react';

const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
    const sectionRefs = useRef({});
    const [activeSection, setActiveSection] = useState('MyReports');

    const scrollToSection = key => {
        const section = sectionRefs.current[key];
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <ScrollContext.Provider value={{ sectionRefs, scrollToSection, activeSection, setActiveSection }}>
            {children}
        </ScrollContext.Provider>
    );
};

export const useScroll = () => {
    const context = useContext(ScrollContext);
    if (!context) {
        throw new Error('useScroll must be used within a ScrollProvider');
    }
    return context;
};
